export const JIRA_COLLECTOR_SCRIPT = 'https://rapid-engineering.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/sb' +
  '53l8/b/2/bc54840da492f9ca037209037ef0522a/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collecto' +
  'r-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=e' +
  'n-US&collectorId=e443119a';
